export enum ContentKind {
    Artist = 'artist',
    Album = 'album',
    MusicVideo = 'musicVideo', // TODO: Are videos supported?
    Playlist = 'playlist',
    PlaylistFolder = 'playlistFolder',
    RadioStation = 'radioStation',
    Song = 'song',
    Work = 'work',
}

export declare type SectionItemKind =
    | 'artistDetailHeaderLockup'
    | 'containerDetailHeaderLockup';
